module.exports = __webpack_public_path__ + "static/media/yandex-international.abd1d6fc.svg";